// core
import { Component, OnInit, OnDestroy, Input, ElementRef } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { Subscription } from "rxjs";
import { startWith } from 'rxjs/operators';
import { distinctUntilChanged } from "rxjs/operators";
// Raptor
import { RaptorPredicateService } from '../../services/raptor-predicate.service';
import { RaptorControlService } from '../../services/raptor-control.service';
@Component({
  selector: 'open-raptor-info',
  templateUrl: './raptor-info.component.html',
  styleUrls: ['./raptor-info.component.scss']
})
export class RaptorInfoComponent implements OnInit, OnDestroy {
  @Input() info: any;
  @Input() form!: FormGroup;

  type!: string;
  showInfo = false;
  formValueWatcher!: Subscription;
  numberOfAccordions = 0;
  infoClass = '';

  constructor(
    private raptorControlService: RaptorControlService,
    private predicateService: RaptorPredicateService,
    private container:ElementRef
  ) { }

  ngOnInit(): void {
    this.type = typeof this.info.content === 'string' ? 'html' : 'object';
    if (this.info && Array.isArray(this.info.content)) {
      this.numberOfAccordions = this.info.content.filter((content: any) => {
        return content.accordion;
      }).length;
    }
    this.checkShowIf();
    this.getInfoClass();

    this.formValueWatcher = this.form.valueChanges
      .pipe(
        startWith(this.form.value),
        distinctUntilChanged((previous, current) => {
          return !this.raptorControlService.formValueChanged(previous, current);
        })
      )
      .subscribe(data => {
        this.checkShowIf();
      });
  }

  ngOnDestroy(): void {
    if (this.formValueWatcher) {
      this.formValueWatcher.unsubscribe();
    }
  }

  getInfoClass() {
    const infoTypeClasses: { [key: string]: string } = {
      error: 'is-error',
      success: 'is-success',
      promo: 'is-promo',
      scripting: 'is-scripting',
      warning: 'is-warning'
    };

    this.infoClass = infoTypeClasses[this.info.type] || '';
  }

  checkShowIf(): void {
    const currentlyVisible = this.showInfo;
    if (this.info.show_if && typeof this.info.show_if === 'object') {
      this.showInfo = this.predicateService.validator(this.info.show_if, this.form.value);
    } else {
      this.showInfo = true;
    }

    if ((this.showInfo && !currentlyVisible) && this.info?.settings?.scroll_on_show_if) {
      requestAnimationFrame(() => {
        this.container.nativeElement.scrollIntoView({ behavior: 'smooth', block: 'start' });
      });
    }

    if (Array.isArray(this.info.content)) {
      this.info.content.forEach((content: any) => {
        if (content.show_if) {
          content.hidden = !this.predicateService.validator(content.show_if, this.form.value);
        }
      });
    }
  }

}
